export const ESTADOS = [
  { codigoUf: 27, sigla: 'AL', unidadeFederativa: 'Alagoas' },
  { codigoUf: 12, sigla: 'AC', unidadeFederativa: 'Acre' },
  { codigoUf: 16, sigla: 'AP', unidadeFederativa: 'Amapá' },
  { codigoUf: 13, sigla: 'AM', unidadeFederativa: 'Amazonas' },
  { codigoUf: 29, sigla: 'BA', unidadeFederativa: 'Bahia' },
  { codigoUf: 23, sigla: 'CE', unidadeFederativa: 'Ceará' },
  { codigoUf: 53, sigla: 'DF', unidadeFederativa: 'Distrito Federal' },
  { codigoUf: 32, sigla: 'ES', unidadeFederativa: 'Espírito Santo' },
  { codigoUf: 52, sigla: 'GO', unidadeFederativa: 'Goías' },
  { codigoUf: 21, sigla: 'MA', unidadeFederativa: 'Maranhão' },
  { codigoUf: 51, sigla: 'MT', unidadeFederativa: 'Mato Grosso' },
  { codigoUf: 50, sigla: 'MS', unidadeFederativa: 'Mato Grosso do Sul' },
  { codigoUf: 31, sigla: 'MG', unidadeFederativa: 'Minas Gerais' },
  { codigoUf: 15, sigla: 'PA', unidadeFederativa: 'Pará' },
  { codigoUf: 25, sigla: 'PB', unidadeFederativa: 'Paraíba' },
  { codigoUf: 41, sigla: 'PR', unidadeFederativa: 'Paraná' },
  { codigoUf: 26, sigla: 'PE', unidadeFederativa: 'Pernambuco' },
  { codigoUf: 22, sigla: 'PI', unidadeFederativa: 'Piauí' },
  { codigoUf: 33, sigla: 'RJ', unidadeFederativa: 'Rio de Janeiro' },
  { codigoUf: 24, sigla: 'RN', unidadeFederativa: 'Rio Grande do Norte' },
  { codigoUf: 43, sigla: 'RS', unidadeFederativa: 'Rio Grande do Sul' },
  { codigoUf: 11, sigla: 'RO', unidadeFederativa: 'Rondônia' },
  { codigoUf: 14, sigla: 'RR', unidadeFederativa: 'Roraíma' },
  { codigoUf: 42, sigla: 'SC', unidadeFederativa: 'Santa Catarina' },
  { codigoUf: 35, sigla: 'SP', unidadeFederativa: 'São Paulo' },
  { codigoUf: 28, sigla: 'SE', unidadeFederativa: 'Sergipe' },
  { codigoUf: 17, sigla: 'TO', unidadeFederativa: 'Tocantins' },
];
